import { render, staticRenderFns } from "./create-account.vue?vue&type=template&id=60608ac4&scoped=true&"
import script from "./create-account.vue?vue&type=script&lang=js&"
export * from "./create-account.vue?vue&type=script&lang=js&"
import style0 from "./create-account.vue?vue&type=style&index=0&id=60608ac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60608ac4",
  null
  
)

/* custom blocks */
import block0 from "./create-account.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports